<template>
  <div id="store-info">
    <v-card
      min-height="700px"
      flat
      outlined
      class="pa-3"
    >
      StoreId:
      <h2 class="pl-4">
        {{ store.id }}
      </h2>
      Name:
      <h2 class="pl-4">
        {{ store.name }}
      </h2>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "StoreInfo",
  data() {
    return {
      storeId: parseInt(this.$route.params.storeId),
      store: {}
    };
  },
  created() {
    this.init();
  },
  methods: {
    fetchStoreInfo(storeID) {
      console.log("Fetching store info", { storeID: storeID });
      this.store = {
        id: this.storeId
      };
    },
    init() {
      this.fetchStoreInfo(this.storeId);
    }
  }
};
</script>